import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { FilterComponentProp } from '../hocs/types'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { SearchFiltersCheckbox } from '../../components/search-filters-checkbox/search-filters-checkbox'

export const POA = withFacetContext(
    FacetName.poa,
    withFilterContext<FilterComponentProp>(FilterName.poa, SearchFiltersCheckbox, {
        title: "Hide 'Price on Asking' adverts",
        options: [{ value: 'exclude', label: 'exclude', count: null }],
    })
)
